export default {
  "root": "_root_1tbu9_1",
  "icon": "_icon_1tbu9_1",
  "content": "_content_1tbu9_1",
  "--rounded-corners": "_--rounded-corners_1tbu9_1",
  "--size-small": "_--size-small_1tbu9_1",
  "--size-medium": "_--size-medium_1tbu9_1",
  "--size-large": "_--size-large_1tbu9_1",
  "--color-neutral": "_--color-neutral_1tbu9_1",
  "--highlighted": "_--highlighted_1tbu9_1",
  "--selected": "_--selected_1tbu9_1",
  "--color-critical": "_--color-critical_1tbu9_1",
  "--color-primary": "_--color-primary_1tbu9_1",
  "--disabled": "_--disabled_1tbu9_1",
  "aligner": "_aligner_1tbu9_1",
  "--rounded-corners-true--m": "_--rounded-corners-true--m_1tbu9_1",
  "--rounded-corners-false--m": "_--rounded-corners-false--m_1tbu9_1",
  "--size-small--m": "_--size-small--m_1tbu9_1",
  "--size-medium--m": "_--size-medium--m_1tbu9_1",
  "--size-large--m": "_--size-large--m_1tbu9_1",
  "--rounded-corners-true--l": "_--rounded-corners-true--l_1tbu9_1",
  "--rounded-corners-false--l": "_--rounded-corners-false--l_1tbu9_1",
  "--size-small--l": "_--size-small--l_1tbu9_1",
  "--size-medium--l": "_--size-medium--l_1tbu9_1",
  "--size-large--l": "_--size-large--l_1tbu9_1",
  "--rounded-corners-true--xl": "_--rounded-corners-true--xl_1tbu9_1",
  "--rounded-corners-false--xl": "_--rounded-corners-false--xl_1tbu9_1",
  "--size-small--xl": "_--size-small--xl_1tbu9_1",
  "--size-medium--xl": "_--size-medium--xl_1tbu9_1",
  "--size-large--xl": "_--size-large--xl_1tbu9_1"
};import "ni:sha-256;mUEp8NPjfKhpMHMNhmv7yX0EPE2J8UpLlaktoYhvNG0";